import React from 'react';
import {useTranslation} from "react-i18next";

const ServerFailed = () => {

    const { t } = useTranslation();

    return (
        <div
            style={{
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center'
            }}
        >
            <div
                style={{
                    width: '100%',
                    textAlign: 'center'
                }}
            >
                <span
                    style={{
                        fontSize: '20px',
                        fontWeight: 'bold'
                    }}
                >
                    {t("menu.boothControl.infoMessage.serviceUnavailable")}
                </span>
            </div>
            <div
                style={{
                    marginTop: '15px',
                    width: '100%',
                    textAlign: 'center'
                }}
            >
                <span
                    style={{
                        color: '#757575'
                    }}
                >
                    {t("menu.boothControl.infoMessage.serverFailed")}
                </span>
            </div>
        </div>
    );
};

export default ServerFailed;